module.exports = __webpack_public_path__ + "static/media/not-found-img.01a56291.svg";